import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Hero from "@/components/home/Hero";
import ProofStrip from "@/components/home/ProofStrip";
import ProductTour from "@/components/home/ProductTour";
import BrokerSync from "@/components/home/BrokerSync";
import Plans from "@/components/home/Plans";
import Privacy from "@/components/home/Privacy";
import LearnPlan from "@/components/home/LearnPlan";
import HomeFAQ from "@/components/home/HomeFAQ";
import FinalCTA from "@/components/home/FinalCTA";
import MobileInstallBar from "@/components/home/MobileInstallBar";
import { useScrollDepth } from "@/hooks/useScrollDepth";
import "@/components/home/home.css";

const TITLE = "PieFolio AI – Know What You Own: Health Score & AI Analysis";
const DESCRIPTION =
  "Know what you own. PieFolio gives you a portfolio Health score, AI analysis in plain words and every dividend date in one calm app. Free on iPhone & Android.";

const Index = () => {
  useScrollDepth();

  // Deep links like "/#plans" from other pages: the global ScrollToTop runs on
  // route change, so scroll to the target after this page has rendered.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const frame = requestAnimationFrame(() => {
      document.getElementById(decodeURIComponent(id))?.scrollIntoView({ behavior: "instant", block: "start" });
    });
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <div className="pf-home min-h-screen overflow-x-clip bg-background pb-[88px] text-foreground antialiased md:pb-0">
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href="https://getpiefolio.com/" />
        <meta property="og:title" content="PieFolio AI – Know what you own" />
        <meta
          property="og:description"
          content="Health score, AI analysis and every dividend date in one calm app. Free on iPhone & Android."
        />
        <meta property="og:url" content="https://getpiefolio.com/" />
      </Helmet>
      <Header />
      <main className="pt-[60px]">
        <div data-track-section="hero">
          <Hero />
        </div>
        <div data-track-section="proof">
          <ProofStrip />
        </div>
        <div data-track-section="features">
          <ProductTour />
        </div>
        <div data-track-section="broker_sync">
          <BrokerSync />
        </div>
        <div data-track-section="plans">
          <Plans />
        </div>
        <div data-track-section="privacy">
          <Privacy />
        </div>
        <div data-track-section="learn">
          <LearnPlan />
        </div>
        <div data-track-section="faq">
          <HomeFAQ />
        </div>
        <div data-track-section="download">
          <FinalCTA />
        </div>
      </main>
      <Footer />
      <MobileInstallBar />
    </div>
  );
};

export default Index;
